import { Component } from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';
import { DocumentService } from 'app/document/services/document.service';
import { WorkoutType } from 'fitforce-document-sync';

export enum DocumentAddWorkoutDialogResult {
  AddCustomWorkout,
  AddStandardWorkout,
  AddRestrictedWorkout,
  AddFromLibrary,
}

@Component({
  selector: 'document-add-workout-dialog',
  templateUrl: './document-add-workout-dialog.component.html',
  styleUrls: ['./document-add-workout-dialog.component.scss']
})
export class DocumentAddWorkoutDialogComponent {
  readonly customValue = 'custom';
  readonly restrictedValue = 'restricted';
  readonly libraryValue = 'library';

  selected: string;

  get workoutTypes(): WorkoutType[] {
    return this.documentService.store.exerciseProgram.document.workout_types;
  }

  get result(): { workoutType?: WorkoutType, type: DocumentAddWorkoutDialogResult} {
    if (this.selected === this.customValue) {
      return {
        type: DocumentAddWorkoutDialogResult.AddCustomWorkout,
      };
    } else if (this.selected === this.restrictedValue) {
      return {
        type: DocumentAddWorkoutDialogResult.AddRestrictedWorkout,
      };
    } else if (this.selected === this.libraryValue) {
      return {
        type: DocumentAddWorkoutDialogResult.AddFromLibrary,
      };
    } else if (this.selected) {
      const workoutType = this.workoutTypes.find(wkt => wkt.id === this.selected);

      if (workoutType) {
        return {
          workoutType,
          type: DocumentAddWorkoutDialogResult.AddStandardWorkout,
        };
      }
    }
  }

  constructor(private documentService: DocumentService) { }

  updateSelection($event: MatSelectionListChange) {
    this.selected = $event.option.value;
  }
}
